/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as UsageDataRouteImport } from './routes/usage-data';
import { Route as UiKitRouteImport } from './routes/ui-kit';
import { Route as TicketsRouteImport } from './routes/tickets';
import { Route as SupportTeamsRouteImport } from './routes/support-teams';
import { Route as ServicesRouteImport } from './routes/services';
import { Route as ServiceCatalogRouteImport } from './routes/service-catalog';
import { Route as ServiceAssignmentsRouteImport } from './routes/service-assignments';
import { Route as ResetPasswordRouteImport } from './routes/reset-password';
import { Route as ProfileRouteImport } from './routes/profile';
import { Route as ProductUpdatesRouteImport } from './routes/product-updates';
import { Route as PortalRouteImport } from './routes/portal';
import { Route as PaymentCardsRouteImport } from './routes/payment-cards';
import { Route as OrgStructureRouteImport } from './routes/org-structure';
import { Route as MessagesRouteImport } from './routes/messages';
import { Route as MeetingsRouteImport } from './routes/meetings';
import { Route as LoginRouteImport } from './routes/login';
import { Route as InvoicesRouteImport } from './routes/invoices';
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password';
import { Route as FinanceRouteImport } from './routes/finance';
import { Route as EmployeesRouteImport } from './routes/employees';
import { Route as ContactsRouteImport } from './routes/contacts';
import { Route as ClientsRouteImport } from './routes/clients';
import { Route as CampaignForecastRouteImport } from './routes/campaign-forecast';
import { Route as BillingProfilesRouteImport } from './routes/billing-profiles';
import { Route as AssetsRouteImport } from './routes/assets';
import { Route as ActivityLogRouteImport } from './routes/activity-log';
import { Route as AccountsRouteImport } from './routes/accounts';
import { Route as AccessRightsRouteImport } from './routes/access-rights';
import { Route as IndexRouteImport } from './routes/index';
import { Route as TicketsIndexRouteImport } from './routes/tickets.index';
import { Route as PortalIndexRouteImport } from './routes/portal.index';
import { Route as InvoicesIndexRouteImport } from './routes/invoices.index';
import { Route as ClientsIndexRouteImport } from './routes/clients.index';
import { Route as AccountsIndexRouteImport } from './routes/accounts.index';
import { Route as TicketsIdRouteImport } from './routes/tickets.$id';
import { Route as PortalTicketsRouteImport } from './routes/portal.tickets';
import { Route as PortalProfileRouteImport } from './routes/portal.profile';
import { Route as PortalProductUpdatesRouteImport } from './routes/portal.product-updates';
import { Route as PortalMessagesRouteImport } from './routes/portal.messages';
import { Route as PortalInvoicesRouteImport } from './routes/portal.invoices';
import { Route as InvoicesNewRouteImport } from './routes/invoices.new';
import { Route as InvoicesIdRouteImport } from './routes/invoices.$id';
import { Route as ClientsNewRouteImport } from './routes/clients.new';
import { Route as ClientsIdRouteImport } from './routes/clients.$id';
import { Route as AccountsNewRouteImport } from './routes/accounts.new';
import { Route as AccountsIdRouteImport } from './routes/accounts.$id';
import { Route as PortalTicketsIndexRouteImport } from './routes/portal.tickets.index';
import { Route as InvoicesIdIndexRouteImport } from './routes/invoices.$id.index';
import { Route as PortalTicketsNewRouteImport } from './routes/portal.tickets.new';
import { Route as PortalTicketsIdRouteImport } from './routes/portal.tickets.$id';
import { Route as PortalLegalImprintRouteImport } from './routes/portal.legal.imprint';
import { Route as PortalLegalGdprRouteImport } from './routes/portal.legal.gdpr';
import { Route as InvoicesIdEditRouteImport } from './routes/invoices.$id.edit';

const UsageDataRoute = UsageDataRouteImport.update({
  id: '/usage-data',
  path: '/usage-data',
  getParentRoute: () => rootRouteImport,
} as any);
const UiKitRoute = UiKitRouteImport.update({
  id: '/ui-kit',
  path: '/ui-kit',
  getParentRoute: () => rootRouteImport,
} as any);
const TicketsRoute = TicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => rootRouteImport,
} as any);
const SupportTeamsRoute = SupportTeamsRouteImport.update({
  id: '/support-teams',
  path: '/support-teams',
  getParentRoute: () => rootRouteImport,
} as any);
const ServicesRoute = ServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any);
const ServiceCatalogRoute = ServiceCatalogRouteImport.update({
  id: '/service-catalog',
  path: '/service-catalog',
  getParentRoute: () => rootRouteImport,
} as any);
const ServiceAssignmentsRoute = ServiceAssignmentsRouteImport.update({
  id: '/service-assignments',
  path: '/service-assignments',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any);
const ProductUpdatesRoute = ProductUpdatesRouteImport.update({
  id: '/product-updates',
  path: '/product-updates',
  getParentRoute: () => rootRouteImport,
} as any);
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any);
const PaymentCardsRoute = PaymentCardsRouteImport.update({
  id: '/payment-cards',
  path: '/payment-cards',
  getParentRoute: () => rootRouteImport,
} as any);
const OrgStructureRoute = OrgStructureRouteImport.update({
  id: '/org-structure',
  path: '/org-structure',
  getParentRoute: () => rootRouteImport,
} as any);
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any);
const MeetingsRoute = MeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any);
const EmployeesRoute = EmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => rootRouteImport,
} as any);
const ContactsRoute = ContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => rootRouteImport,
} as any);
const ClientsRoute = ClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRouteImport,
} as any);
const CampaignForecastRoute = CampaignForecastRouteImport.update({
  id: '/campaign-forecast',
  path: '/campaign-forecast',
  getParentRoute: () => rootRouteImport,
} as any);
const BillingProfilesRoute = BillingProfilesRouteImport.update({
  id: '/billing-profiles',
  path: '/billing-profiles',
  getParentRoute: () => rootRouteImport,
} as any);
const AssetsRoute = AssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => rootRouteImport,
} as any);
const ActivityLogRoute = ActivityLogRouteImport.update({
  id: '/activity-log',
  path: '/activity-log',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountsRoute = AccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRouteImport,
} as any);
const AccessRightsRoute = AccessRightsRouteImport.update({
  id: '/access-rights',
  path: '/access-rights',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TicketsRoute,
} as any);
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any);
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InvoicesRoute,
} as any);
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientsRoute,
} as any);
const AccountsIndexRoute = AccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountsRoute,
} as any);
const TicketsIdRoute = TicketsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TicketsRoute,
} as any);
const PortalTicketsRoute = PortalTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => PortalRoute,
} as any);
const PortalProfileRoute = PortalProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => PortalRoute,
} as any);
const PortalProductUpdatesRoute = PortalProductUpdatesRouteImport.update({
  id: '/product-updates',
  path: '/product-updates',
  getParentRoute: () => PortalRoute,
} as any);
const PortalMessagesRoute = PortalMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => PortalRoute,
} as any);
const PortalInvoicesRoute = PortalInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => PortalRoute,
} as any);
const InvoicesNewRoute = InvoicesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => InvoicesRoute,
} as any);
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => InvoicesRoute,
} as any);
const ClientsNewRoute = ClientsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ClientsRoute,
} as any);
const ClientsIdRoute = ClientsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ClientsRoute,
} as any);
const AccountsNewRoute = AccountsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AccountsRoute,
} as any);
const AccountsIdRoute = AccountsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AccountsRoute,
} as any);
const PortalTicketsIndexRoute = PortalTicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalTicketsRoute,
} as any);
const InvoicesIdIndexRoute = InvoicesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InvoicesIdRoute,
} as any);
const PortalTicketsNewRoute = PortalTicketsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => PortalTicketsRoute,
} as any);
const PortalTicketsIdRoute = PortalTicketsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PortalTicketsRoute,
} as any);
const PortalLegalImprintRoute = PortalLegalImprintRouteImport.update({
  id: '/legal/imprint',
  path: '/legal/imprint',
  getParentRoute: () => PortalRoute,
} as any);
const PortalLegalGdprRoute = PortalLegalGdprRouteImport.update({
  id: '/legal/gdpr',
  path: '/legal/gdpr',
  getParentRoute: () => PortalRoute,
} as any);
const InvoicesIdEditRoute = InvoicesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => InvoicesIdRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/access-rights': typeof AccessRightsRoute;
  '/accounts': typeof AccountsRouteWithChildren;
  '/activity-log': typeof ActivityLogRoute;
  '/assets': typeof AssetsRoute;
  '/billing-profiles': typeof BillingProfilesRoute;
  '/campaign-forecast': typeof CampaignForecastRoute;
  '/clients': typeof ClientsRouteWithChildren;
  '/contacts': typeof ContactsRoute;
  '/employees': typeof EmployeesRoute;
  '/finance': typeof FinanceRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/invoices': typeof InvoicesRouteWithChildren;
  '/login': typeof LoginRoute;
  '/meetings': typeof MeetingsRoute;
  '/messages': typeof MessagesRoute;
  '/org-structure': typeof OrgStructureRoute;
  '/payment-cards': typeof PaymentCardsRoute;
  '/portal': typeof PortalRouteWithChildren;
  '/product-updates': typeof ProductUpdatesRoute;
  '/profile': typeof ProfileRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/service-assignments': typeof ServiceAssignmentsRoute;
  '/service-catalog': typeof ServiceCatalogRoute;
  '/services': typeof ServicesRoute;
  '/support-teams': typeof SupportTeamsRoute;
  '/tickets': typeof TicketsRouteWithChildren;
  '/ui-kit': typeof UiKitRoute;
  '/usage-data': typeof UsageDataRoute;
  '/accounts/$id': typeof AccountsIdRoute;
  '/accounts/new': typeof AccountsNewRoute;
  '/clients/$id': typeof ClientsIdRoute;
  '/clients/new': typeof ClientsNewRoute;
  '/invoices/$id': typeof InvoicesIdRouteWithChildren;
  '/invoices/new': typeof InvoicesNewRoute;
  '/portal/invoices': typeof PortalInvoicesRoute;
  '/portal/messages': typeof PortalMessagesRoute;
  '/portal/product-updates': typeof PortalProductUpdatesRoute;
  '/portal/profile': typeof PortalProfileRoute;
  '/portal/tickets': typeof PortalTicketsRouteWithChildren;
  '/tickets/$id': typeof TicketsIdRoute;
  '/accounts/': typeof AccountsIndexRoute;
  '/clients/': typeof ClientsIndexRoute;
  '/invoices/': typeof InvoicesIndexRoute;
  '/portal/': typeof PortalIndexRoute;
  '/tickets/': typeof TicketsIndexRoute;
  '/invoices/$id/edit': typeof InvoicesIdEditRoute;
  '/portal/legal/gdpr': typeof PortalLegalGdprRoute;
  '/portal/legal/imprint': typeof PortalLegalImprintRoute;
  '/portal/tickets/$id': typeof PortalTicketsIdRoute;
  '/portal/tickets/new': typeof PortalTicketsNewRoute;
  '/invoices/$id/': typeof InvoicesIdIndexRoute;
  '/portal/tickets/': typeof PortalTicketsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/access-rights': typeof AccessRightsRoute;
  '/activity-log': typeof ActivityLogRoute;
  '/assets': typeof AssetsRoute;
  '/billing-profiles': typeof BillingProfilesRoute;
  '/campaign-forecast': typeof CampaignForecastRoute;
  '/contacts': typeof ContactsRoute;
  '/employees': typeof EmployeesRoute;
  '/finance': typeof FinanceRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/meetings': typeof MeetingsRoute;
  '/messages': typeof MessagesRoute;
  '/org-structure': typeof OrgStructureRoute;
  '/payment-cards': typeof PaymentCardsRoute;
  '/product-updates': typeof ProductUpdatesRoute;
  '/profile': typeof ProfileRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/service-assignments': typeof ServiceAssignmentsRoute;
  '/service-catalog': typeof ServiceCatalogRoute;
  '/services': typeof ServicesRoute;
  '/support-teams': typeof SupportTeamsRoute;
  '/ui-kit': typeof UiKitRoute;
  '/usage-data': typeof UsageDataRoute;
  '/accounts/$id': typeof AccountsIdRoute;
  '/accounts/new': typeof AccountsNewRoute;
  '/clients/$id': typeof ClientsIdRoute;
  '/clients/new': typeof ClientsNewRoute;
  '/invoices/new': typeof InvoicesNewRoute;
  '/portal/invoices': typeof PortalInvoicesRoute;
  '/portal/messages': typeof PortalMessagesRoute;
  '/portal/product-updates': typeof PortalProductUpdatesRoute;
  '/portal/profile': typeof PortalProfileRoute;
  '/tickets/$id': typeof TicketsIdRoute;
  '/accounts': typeof AccountsIndexRoute;
  '/clients': typeof ClientsIndexRoute;
  '/invoices': typeof InvoicesIndexRoute;
  '/portal': typeof PortalIndexRoute;
  '/tickets': typeof TicketsIndexRoute;
  '/invoices/$id/edit': typeof InvoicesIdEditRoute;
  '/portal/legal/gdpr': typeof PortalLegalGdprRoute;
  '/portal/legal/imprint': typeof PortalLegalImprintRoute;
  '/portal/tickets/$id': typeof PortalTicketsIdRoute;
  '/portal/tickets/new': typeof PortalTicketsNewRoute;
  '/invoices/$id': typeof InvoicesIdIndexRoute;
  '/portal/tickets': typeof PortalTicketsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/access-rights': typeof AccessRightsRoute;
  '/accounts': typeof AccountsRouteWithChildren;
  '/activity-log': typeof ActivityLogRoute;
  '/assets': typeof AssetsRoute;
  '/billing-profiles': typeof BillingProfilesRoute;
  '/campaign-forecast': typeof CampaignForecastRoute;
  '/clients': typeof ClientsRouteWithChildren;
  '/contacts': typeof ContactsRoute;
  '/employees': typeof EmployeesRoute;
  '/finance': typeof FinanceRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/invoices': typeof InvoicesRouteWithChildren;
  '/login': typeof LoginRoute;
  '/meetings': typeof MeetingsRoute;
  '/messages': typeof MessagesRoute;
  '/org-structure': typeof OrgStructureRoute;
  '/payment-cards': typeof PaymentCardsRoute;
  '/portal': typeof PortalRouteWithChildren;
  '/product-updates': typeof ProductUpdatesRoute;
  '/profile': typeof ProfileRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/service-assignments': typeof ServiceAssignmentsRoute;
  '/service-catalog': typeof ServiceCatalogRoute;
  '/services': typeof ServicesRoute;
  '/support-teams': typeof SupportTeamsRoute;
  '/tickets': typeof TicketsRouteWithChildren;
  '/ui-kit': typeof UiKitRoute;
  '/usage-data': typeof UsageDataRoute;
  '/accounts/$id': typeof AccountsIdRoute;
  '/accounts/new': typeof AccountsNewRoute;
  '/clients/$id': typeof ClientsIdRoute;
  '/clients/new': typeof ClientsNewRoute;
  '/invoices/$id': typeof InvoicesIdRouteWithChildren;
  '/invoices/new': typeof InvoicesNewRoute;
  '/portal/invoices': typeof PortalInvoicesRoute;
  '/portal/messages': typeof PortalMessagesRoute;
  '/portal/product-updates': typeof PortalProductUpdatesRoute;
  '/portal/profile': typeof PortalProfileRoute;
  '/portal/tickets': typeof PortalTicketsRouteWithChildren;
  '/tickets/$id': typeof TicketsIdRoute;
  '/accounts/': typeof AccountsIndexRoute;
  '/clients/': typeof ClientsIndexRoute;
  '/invoices/': typeof InvoicesIndexRoute;
  '/portal/': typeof PortalIndexRoute;
  '/tickets/': typeof TicketsIndexRoute;
  '/invoices/$id/edit': typeof InvoicesIdEditRoute;
  '/portal/legal/gdpr': typeof PortalLegalGdprRoute;
  '/portal/legal/imprint': typeof PortalLegalImprintRoute;
  '/portal/tickets/$id': typeof PortalTicketsIdRoute;
  '/portal/tickets/new': typeof PortalTicketsNewRoute;
  '/invoices/$id/': typeof InvoicesIdIndexRoute;
  '/portal/tickets/': typeof PortalTicketsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/access-rights'
    | '/accounts'
    | '/activity-log'
    | '/assets'
    | '/billing-profiles'
    | '/campaign-forecast'
    | '/clients'
    | '/contacts'
    | '/employees'
    | '/finance'
    | '/forgot-password'
    | '/invoices'
    | '/login'
    | '/meetings'
    | '/messages'
    | '/org-structure'
    | '/payment-cards'
    | '/portal'
    | '/product-updates'
    | '/profile'
    | '/reset-password'
    | '/service-assignments'
    | '/service-catalog'
    | '/services'
    | '/support-teams'
    | '/tickets'
    | '/ui-kit'
    | '/usage-data'
    | '/accounts/$id'
    | '/accounts/new'
    | '/clients/$id'
    | '/clients/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/portal/invoices'
    | '/portal/messages'
    | '/portal/product-updates'
    | '/portal/profile'
    | '/portal/tickets'
    | '/tickets/$id'
    | '/accounts/'
    | '/clients/'
    | '/invoices/'
    | '/portal/'
    | '/tickets/'
    | '/invoices/$id/edit'
    | '/portal/legal/gdpr'
    | '/portal/legal/imprint'
    | '/portal/tickets/$id'
    | '/portal/tickets/new'
    | '/invoices/$id/'
    | '/portal/tickets/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/access-rights'
    | '/activity-log'
    | '/assets'
    | '/billing-profiles'
    | '/campaign-forecast'
    | '/contacts'
    | '/employees'
    | '/finance'
    | '/forgot-password'
    | '/login'
    | '/meetings'
    | '/messages'
    | '/org-structure'
    | '/payment-cards'
    | '/product-updates'
    | '/profile'
    | '/reset-password'
    | '/service-assignments'
    | '/service-catalog'
    | '/services'
    | '/support-teams'
    | '/ui-kit'
    | '/usage-data'
    | '/accounts/$id'
    | '/accounts/new'
    | '/clients/$id'
    | '/clients/new'
    | '/invoices/new'
    | '/portal/invoices'
    | '/portal/messages'
    | '/portal/product-updates'
    | '/portal/profile'
    | '/tickets/$id'
    | '/accounts'
    | '/clients'
    | '/invoices'
    | '/portal'
    | '/tickets'
    | '/invoices/$id/edit'
    | '/portal/legal/gdpr'
    | '/portal/legal/imprint'
    | '/portal/tickets/$id'
    | '/portal/tickets/new'
    | '/invoices/$id'
    | '/portal/tickets';
  id:
    | '__root__'
    | '/'
    | '/access-rights'
    | '/accounts'
    | '/activity-log'
    | '/assets'
    | '/billing-profiles'
    | '/campaign-forecast'
    | '/clients'
    | '/contacts'
    | '/employees'
    | '/finance'
    | '/forgot-password'
    | '/invoices'
    | '/login'
    | '/meetings'
    | '/messages'
    | '/org-structure'
    | '/payment-cards'
    | '/portal'
    | '/product-updates'
    | '/profile'
    | '/reset-password'
    | '/service-assignments'
    | '/service-catalog'
    | '/services'
    | '/support-teams'
    | '/tickets'
    | '/ui-kit'
    | '/usage-data'
    | '/accounts/$id'
    | '/accounts/new'
    | '/clients/$id'
    | '/clients/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/portal/invoices'
    | '/portal/messages'
    | '/portal/product-updates'
    | '/portal/profile'
    | '/portal/tickets'
    | '/tickets/$id'
    | '/accounts/'
    | '/clients/'
    | '/invoices/'
    | '/portal/'
    | '/tickets/'
    | '/invoices/$id/edit'
    | '/portal/legal/gdpr'
    | '/portal/legal/imprint'
    | '/portal/tickets/$id'
    | '/portal/tickets/new'
    | '/invoices/$id/'
    | '/portal/tickets/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AccessRightsRoute: typeof AccessRightsRoute;
  AccountsRoute: typeof AccountsRouteWithChildren;
  ActivityLogRoute: typeof ActivityLogRoute;
  AssetsRoute: typeof AssetsRoute;
  BillingProfilesRoute: typeof BillingProfilesRoute;
  CampaignForecastRoute: typeof CampaignForecastRoute;
  ClientsRoute: typeof ClientsRouteWithChildren;
  ContactsRoute: typeof ContactsRoute;
  EmployeesRoute: typeof EmployeesRoute;
  FinanceRoute: typeof FinanceRoute;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  InvoicesRoute: typeof InvoicesRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  MeetingsRoute: typeof MeetingsRoute;
  MessagesRoute: typeof MessagesRoute;
  OrgStructureRoute: typeof OrgStructureRoute;
  PaymentCardsRoute: typeof PaymentCardsRoute;
  PortalRoute: typeof PortalRouteWithChildren;
  ProductUpdatesRoute: typeof ProductUpdatesRoute;
  ProfileRoute: typeof ProfileRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  ServiceAssignmentsRoute: typeof ServiceAssignmentsRoute;
  ServiceCatalogRoute: typeof ServiceCatalogRoute;
  ServicesRoute: typeof ServicesRoute;
  SupportTeamsRoute: typeof SupportTeamsRoute;
  TicketsRoute: typeof TicketsRouteWithChildren;
  UiKitRoute: typeof UiKitRoute;
  UsageDataRoute: typeof UsageDataRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/usage-data': {
      id: '/usage-data';
      path: '/usage-data';
      fullPath: '/usage-data';
      preLoaderRoute: typeof UsageDataRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ui-kit': {
      id: '/ui-kit';
      path: '/ui-kit';
      fullPath: '/ui-kit';
      preLoaderRoute: typeof UiKitRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tickets': {
      id: '/tickets';
      path: '/tickets';
      fullPath: '/tickets';
      preLoaderRoute: typeof TicketsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/support-teams': {
      id: '/support-teams';
      path: '/support-teams';
      fullPath: '/support-teams';
      preLoaderRoute: typeof SupportTeamsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/services': {
      id: '/services';
      path: '/services';
      fullPath: '/services';
      preLoaderRoute: typeof ServicesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/service-catalog': {
      id: '/service-catalog';
      path: '/service-catalog';
      fullPath: '/service-catalog';
      preLoaderRoute: typeof ServiceCatalogRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/service-assignments': {
      id: '/service-assignments';
      path: '/service-assignments';
      fullPath: '/service-assignments';
      preLoaderRoute: typeof ServiceAssignmentsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/profile': {
      id: '/profile';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof ProfileRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/product-updates': {
      id: '/product-updates';
      path: '/product-updates';
      fullPath: '/product-updates';
      preLoaderRoute: typeof ProductUpdatesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/portal': {
      id: '/portal';
      path: '/portal';
      fullPath: '/portal';
      preLoaderRoute: typeof PortalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/payment-cards': {
      id: '/payment-cards';
      path: '/payment-cards';
      fullPath: '/payment-cards';
      preLoaderRoute: typeof PaymentCardsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/org-structure': {
      id: '/org-structure';
      path: '/org-structure';
      fullPath: '/org-structure';
      preLoaderRoute: typeof OrgStructureRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/messages': {
      id: '/messages';
      path: '/messages';
      fullPath: '/messages';
      preLoaderRoute: typeof MessagesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/meetings': {
      id: '/meetings';
      path: '/meetings';
      fullPath: '/meetings';
      preLoaderRoute: typeof MeetingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/invoices': {
      id: '/invoices';
      path: '/invoices';
      fullPath: '/invoices';
      preLoaderRoute: typeof InvoicesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forgot-password': {
      id: '/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/finance': {
      id: '/finance';
      path: '/finance';
      fullPath: '/finance';
      preLoaderRoute: typeof FinanceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/employees': {
      id: '/employees';
      path: '/employees';
      fullPath: '/employees';
      preLoaderRoute: typeof EmployeesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/contacts': {
      id: '/contacts';
      path: '/contacts';
      fullPath: '/contacts';
      preLoaderRoute: typeof ContactsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/clients': {
      id: '/clients';
      path: '/clients';
      fullPath: '/clients';
      preLoaderRoute: typeof ClientsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/campaign-forecast': {
      id: '/campaign-forecast';
      path: '/campaign-forecast';
      fullPath: '/campaign-forecast';
      preLoaderRoute: typeof CampaignForecastRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/billing-profiles': {
      id: '/billing-profiles';
      path: '/billing-profiles';
      fullPath: '/billing-profiles';
      preLoaderRoute: typeof BillingProfilesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/assets': {
      id: '/assets';
      path: '/assets';
      fullPath: '/assets';
      preLoaderRoute: typeof AssetsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/activity-log': {
      id: '/activity-log';
      path: '/activity-log';
      fullPath: '/activity-log';
      preLoaderRoute: typeof ActivityLogRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accounts': {
      id: '/accounts';
      path: '/accounts';
      fullPath: '/accounts';
      preLoaderRoute: typeof AccountsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/access-rights': {
      id: '/access-rights';
      path: '/access-rights';
      fullPath: '/access-rights';
      preLoaderRoute: typeof AccessRightsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tickets/': {
      id: '/tickets/';
      path: '/';
      fullPath: '/tickets/';
      preLoaderRoute: typeof TicketsIndexRouteImport;
      parentRoute: typeof TicketsRoute;
    };
    '/portal/': {
      id: '/portal/';
      path: '/';
      fullPath: '/portal/';
      preLoaderRoute: typeof PortalIndexRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/invoices/': {
      id: '/invoices/';
      path: '/';
      fullPath: '/invoices/';
      preLoaderRoute: typeof InvoicesIndexRouteImport;
      parentRoute: typeof InvoicesRoute;
    };
    '/clients/': {
      id: '/clients/';
      path: '/';
      fullPath: '/clients/';
      preLoaderRoute: typeof ClientsIndexRouteImport;
      parentRoute: typeof ClientsRoute;
    };
    '/accounts/': {
      id: '/accounts/';
      path: '/';
      fullPath: '/accounts/';
      preLoaderRoute: typeof AccountsIndexRouteImport;
      parentRoute: typeof AccountsRoute;
    };
    '/tickets/$id': {
      id: '/tickets/$id';
      path: '/$id';
      fullPath: '/tickets/$id';
      preLoaderRoute: typeof TicketsIdRouteImport;
      parentRoute: typeof TicketsRoute;
    };
    '/portal/tickets': {
      id: '/portal/tickets';
      path: '/tickets';
      fullPath: '/portal/tickets';
      preLoaderRoute: typeof PortalTicketsRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/profile': {
      id: '/portal/profile';
      path: '/profile';
      fullPath: '/portal/profile';
      preLoaderRoute: typeof PortalProfileRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/product-updates': {
      id: '/portal/product-updates';
      path: '/product-updates';
      fullPath: '/portal/product-updates';
      preLoaderRoute: typeof PortalProductUpdatesRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/messages': {
      id: '/portal/messages';
      path: '/messages';
      fullPath: '/portal/messages';
      preLoaderRoute: typeof PortalMessagesRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/invoices': {
      id: '/portal/invoices';
      path: '/invoices';
      fullPath: '/portal/invoices';
      preLoaderRoute: typeof PortalInvoicesRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/invoices/new': {
      id: '/invoices/new';
      path: '/new';
      fullPath: '/invoices/new';
      preLoaderRoute: typeof InvoicesNewRouteImport;
      parentRoute: typeof InvoicesRoute;
    };
    '/invoices/$id': {
      id: '/invoices/$id';
      path: '/$id';
      fullPath: '/invoices/$id';
      preLoaderRoute: typeof InvoicesIdRouteImport;
      parentRoute: typeof InvoicesRoute;
    };
    '/clients/new': {
      id: '/clients/new';
      path: '/new';
      fullPath: '/clients/new';
      preLoaderRoute: typeof ClientsNewRouteImport;
      parentRoute: typeof ClientsRoute;
    };
    '/clients/$id': {
      id: '/clients/$id';
      path: '/$id';
      fullPath: '/clients/$id';
      preLoaderRoute: typeof ClientsIdRouteImport;
      parentRoute: typeof ClientsRoute;
    };
    '/accounts/new': {
      id: '/accounts/new';
      path: '/new';
      fullPath: '/accounts/new';
      preLoaderRoute: typeof AccountsNewRouteImport;
      parentRoute: typeof AccountsRoute;
    };
    '/accounts/$id': {
      id: '/accounts/$id';
      path: '/$id';
      fullPath: '/accounts/$id';
      preLoaderRoute: typeof AccountsIdRouteImport;
      parentRoute: typeof AccountsRoute;
    };
    '/portal/tickets/': {
      id: '/portal/tickets/';
      path: '/';
      fullPath: '/portal/tickets/';
      preLoaderRoute: typeof PortalTicketsIndexRouteImport;
      parentRoute: typeof PortalTicketsRoute;
    };
    '/invoices/$id/': {
      id: '/invoices/$id/';
      path: '/';
      fullPath: '/invoices/$id/';
      preLoaderRoute: typeof InvoicesIdIndexRouteImport;
      parentRoute: typeof InvoicesIdRoute;
    };
    '/portal/tickets/new': {
      id: '/portal/tickets/new';
      path: '/new';
      fullPath: '/portal/tickets/new';
      preLoaderRoute: typeof PortalTicketsNewRouteImport;
      parentRoute: typeof PortalTicketsRoute;
    };
    '/portal/tickets/$id': {
      id: '/portal/tickets/$id';
      path: '/$id';
      fullPath: '/portal/tickets/$id';
      preLoaderRoute: typeof PortalTicketsIdRouteImport;
      parentRoute: typeof PortalTicketsRoute;
    };
    '/portal/legal/imprint': {
      id: '/portal/legal/imprint';
      path: '/legal/imprint';
      fullPath: '/portal/legal/imprint';
      preLoaderRoute: typeof PortalLegalImprintRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/portal/legal/gdpr': {
      id: '/portal/legal/gdpr';
      path: '/legal/gdpr';
      fullPath: '/portal/legal/gdpr';
      preLoaderRoute: typeof PortalLegalGdprRouteImport;
      parentRoute: typeof PortalRoute;
    };
    '/invoices/$id/edit': {
      id: '/invoices/$id/edit';
      path: '/edit';
      fullPath: '/invoices/$id/edit';
      preLoaderRoute: typeof InvoicesIdEditRouteImport;
      parentRoute: typeof InvoicesIdRoute;
    };
  }
}

interface AccountsRouteChildren {
  AccountsIdRoute: typeof AccountsIdRoute;
  AccountsNewRoute: typeof AccountsNewRoute;
  AccountsIndexRoute: typeof AccountsIndexRoute;
}

const AccountsRouteChildren: AccountsRouteChildren = {
  AccountsIdRoute: AccountsIdRoute,
  AccountsNewRoute: AccountsNewRoute,
  AccountsIndexRoute: AccountsIndexRoute,
};

const AccountsRouteWithChildren = AccountsRoute._addFileChildren(
  AccountsRouteChildren,
);

interface ClientsRouteChildren {
  ClientsIdRoute: typeof ClientsIdRoute;
  ClientsNewRoute: typeof ClientsNewRoute;
  ClientsIndexRoute: typeof ClientsIndexRoute;
}

const ClientsRouteChildren: ClientsRouteChildren = {
  ClientsIdRoute: ClientsIdRoute,
  ClientsNewRoute: ClientsNewRoute,
  ClientsIndexRoute: ClientsIndexRoute,
};

const ClientsRouteWithChildren =
  ClientsRoute._addFileChildren(ClientsRouteChildren);

interface InvoicesIdRouteChildren {
  InvoicesIdEditRoute: typeof InvoicesIdEditRoute;
  InvoicesIdIndexRoute: typeof InvoicesIdIndexRoute;
}

const InvoicesIdRouteChildren: InvoicesIdRouteChildren = {
  InvoicesIdEditRoute: InvoicesIdEditRoute,
  InvoicesIdIndexRoute: InvoicesIdIndexRoute,
};

const InvoicesIdRouteWithChildren = InvoicesIdRoute._addFileChildren(
  InvoicesIdRouteChildren,
);

interface InvoicesRouteChildren {
  InvoicesIdRoute: typeof InvoicesIdRouteWithChildren;
  InvoicesNewRoute: typeof InvoicesNewRoute;
  InvoicesIndexRoute: typeof InvoicesIndexRoute;
}

const InvoicesRouteChildren: InvoicesRouteChildren = {
  InvoicesIdRoute: InvoicesIdRouteWithChildren,
  InvoicesNewRoute: InvoicesNewRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
};

const InvoicesRouteWithChildren = InvoicesRoute._addFileChildren(
  InvoicesRouteChildren,
);

interface PortalTicketsRouteChildren {
  PortalTicketsIdRoute: typeof PortalTicketsIdRoute;
  PortalTicketsNewRoute: typeof PortalTicketsNewRoute;
  PortalTicketsIndexRoute: typeof PortalTicketsIndexRoute;
}

const PortalTicketsRouteChildren: PortalTicketsRouteChildren = {
  PortalTicketsIdRoute: PortalTicketsIdRoute,
  PortalTicketsNewRoute: PortalTicketsNewRoute,
  PortalTicketsIndexRoute: PortalTicketsIndexRoute,
};

const PortalTicketsRouteWithChildren = PortalTicketsRoute._addFileChildren(
  PortalTicketsRouteChildren,
);

interface PortalRouteChildren {
  PortalInvoicesRoute: typeof PortalInvoicesRoute;
  PortalMessagesRoute: typeof PortalMessagesRoute;
  PortalProductUpdatesRoute: typeof PortalProductUpdatesRoute;
  PortalProfileRoute: typeof PortalProfileRoute;
  PortalTicketsRoute: typeof PortalTicketsRouteWithChildren;
  PortalIndexRoute: typeof PortalIndexRoute;
  PortalLegalGdprRoute: typeof PortalLegalGdprRoute;
  PortalLegalImprintRoute: typeof PortalLegalImprintRoute;
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalInvoicesRoute: PortalInvoicesRoute,
  PortalMessagesRoute: PortalMessagesRoute,
  PortalProductUpdatesRoute: PortalProductUpdatesRoute,
  PortalProfileRoute: PortalProfileRoute,
  PortalTicketsRoute: PortalTicketsRouteWithChildren,
  PortalIndexRoute: PortalIndexRoute,
  PortalLegalGdprRoute: PortalLegalGdprRoute,
  PortalLegalImprintRoute: PortalLegalImprintRoute,
};

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren);

interface TicketsRouteChildren {
  TicketsIdRoute: typeof TicketsIdRoute;
  TicketsIndexRoute: typeof TicketsIndexRoute;
}

const TicketsRouteChildren: TicketsRouteChildren = {
  TicketsIdRoute: TicketsIdRoute,
  TicketsIndexRoute: TicketsIndexRoute,
};

const TicketsRouteWithChildren =
  TicketsRoute._addFileChildren(TicketsRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessRightsRoute: AccessRightsRoute,
  AccountsRoute: AccountsRouteWithChildren,
  ActivityLogRoute: ActivityLogRoute,
  AssetsRoute: AssetsRoute,
  BillingProfilesRoute: BillingProfilesRoute,
  CampaignForecastRoute: CampaignForecastRoute,
  ClientsRoute: ClientsRouteWithChildren,
  ContactsRoute: ContactsRoute,
  EmployeesRoute: EmployeesRoute,
  FinanceRoute: FinanceRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InvoicesRoute: InvoicesRouteWithChildren,
  LoginRoute: LoginRoute,
  MeetingsRoute: MeetingsRoute,
  MessagesRoute: MessagesRoute,
  OrgStructureRoute: OrgStructureRoute,
  PaymentCardsRoute: PaymentCardsRoute,
  PortalRoute: PortalRouteWithChildren,
  ProductUpdatesRoute: ProductUpdatesRoute,
  ProfileRoute: ProfileRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ServiceAssignmentsRoute: ServiceAssignmentsRoute,
  ServiceCatalogRoute: ServiceCatalogRoute,
  ServicesRoute: ServicesRoute,
  SupportTeamsRoute: SupportTeamsRoute,
  TicketsRoute: TicketsRouteWithChildren,
  UiKitRoute: UiKitRoute,
  UsageDataRoute: UsageDataRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
